/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FenceResult } from '../../models/fence-result';

export interface FenceResultsOnlyReportable$Params {
  raceGuid: string;
  onlyReportable: boolean;
}

export function fenceResultsOnlyReportable(http: HttpClient, rootUrl: string, params: FenceResultsOnlyReportable$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FenceResult>>> {
  const rb = new RequestBuilder(rootUrl, fenceResultsOnlyReportable.PATH, 'get');
  if (params) {
    rb.path('raceGuid', params.raceGuid, {"style":"simple"});
    rb.path('onlyReportable', params.onlyReportable, {"style":"simple"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FenceResult>>;
    })
  );
}

fenceResultsOnlyReportable.PATH = '/races/{raceGuid}/onlyreportable/{onlyReportable}/fenceresults';
